import { UpdateLegalEntity } from "../../Models/LegalEntity";
import api from "../axios";

export const legalEntityService = {
  update: async (data: UpdateLegalEntity): Promise<boolean> => {
    const response = await api.patch('/legal-entity', data);
    return response.data;
  },

  updateCnpj: async (id: string, data: { cnpj: string }): Promise<boolean> => {
    const response = await api.patch(`/legal-entity/${id}/cnpj`, data);
    return response.data;
  },

  updateStateRegistration: async (id: string, data: { stateRegistration: string | null; isStateRegistrationExempt: boolean }): Promise<boolean> => {
    const response = await api.patch(`/legal-entity/${id}/state-registration`, data);
    return response.data;
  }
};
